let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5fAg1")).then(() => parcelRequire('fQp22'));